import { Button, Typography } from "@mui/material";
import ToolTip from "../../ToolTip/ToolTip";

const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};

export const NewInventoryTableHead = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "product_name",
    headerName: "Product Name",
    width: 200,
  },
  {
    field: "total",
    headerName: "Total Stock",
    width: 200,
  },
  {
    field: "currentStock",
    headerName: "Available Stock",
    width: 200,
  },
  {
    field: "saledCount",
    headerName: "Saled Count",
    width: 200,
  },
  {
    field: "damagedCount",
    headerName: "Damaged Count",
    width: 200,
    valueGetter: (params) => params.row.damagedCount,
  },
  //   {
  //     field: "damagedReason",
  //     headerName: "Damaged Reason",
  //     width: 200,
  //     renderCell: (params) => handleToolTip(params.row.damagedReason),
  //   },
];
